import type { CONSORS_CANCEL_SUBSCRIPTION_STATUS } from 'cpool-constants';
import { CONSORS_CANCEL_SUBSCRIPTION_STATUSES } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetConsorsSubscriptionStatus } from 'cpool-tables/backend-resolvers';
import { schemaLoanRequestResolver_GetConsorsSubscriptionStatus } from 'cpool-tables/backend-resolvers';
import { sleep } from 'cpool-utils';
import { type TFunction } from 'i18next';
import { toast } from 'react-toastify';

import { API_EXTERNAL } from '~/config';
import { fetcher } from '~/queryUtils/useQuery';

export const verifyConsorsSubscriptionCancellationStatus = async ({
    loanRequestId,
    subscriptionIdentifier,
    t,
    waitTime = API_EXTERNAL.CONSORS.SUBSCRIPTION_CANCELLATION.RETRY_INTERVAL,
}: {
    loanRequestId: string;
    waitTime?: number;
    t: TFunction<'de' | 'en', undefined>;
    subscriptionIdentifier: string;
}) => {
    try {
        let consorsSubscriptionCancellationStatus: CONSORS_CANCEL_SUBSCRIPTION_STATUS =
            CONSORS_CANCEL_SUBSCRIPTION_STATUSES.PENDING;
        let response: SchemaLoanRequestResolver_GetConsorsSubscriptionStatus = null;
        let counter = 0;
        while (
            consorsSubscriptionCancellationStatus === CONSORS_CANCEL_SUBSCRIPTION_STATUSES.PENDING &&
            counter < API_EXTERNAL.CONSORS.SUBSCRIPTION_CANCELLATION.MAX_RETRIES
        ) {
            // eslint-disable-next-line no-await-in-loop
            await sleep(waitTime);
            // eslint-disable-next-line no-await-in-loop
            response = await fetcher({
                meta: {
                    queryUrl: `/query/loan-request/getConsorsSubscriptionStatus?id=${loanRequestId}&subscriptionIdentifier=${subscriptionIdentifier}`,
                    schema: schemaLoanRequestResolver_GetConsorsSubscriptionStatus,
                },
            });
            if (response && response.cancellationStatus) {
                consorsSubscriptionCancellationStatus = response.cancellationStatus;
            }
            counter += 1;
        }
        if (consorsSubscriptionCancellationStatus === CONSORS_CANCEL_SUBSCRIPTION_STATUSES.PENDING) {
            toast.error(t('CREDIT_WORTHINESS.CONSORS_PROCESS.SUBSCRIPTION_CANCELLATION_TIMEOUT'));
            return;
        }
        if (
            consorsSubscriptionCancellationStatus === CONSORS_CANCEL_SUBSCRIPTION_STATUSES.ERROR ||
            consorsSubscriptionCancellationStatus === null
        ) {
            toast.error(t('CREDIT_WORTHINESS.CONSORS_PROCESS.SUBSCRIPTION_CANCELLATION_FAILED'));
            return;
        }
        toast.success(t('CREDIT_WORTHINESS.CONSORS_PROCESS.SUBSCRIPTION_CANCELLED_SUCCESSFULLY'));
    } catch {
        toast.error(t('CREDIT_WORTHINESS.CONSORS_PROCESS.SUBSCRIPTION_CANCELLATION_FAILED'));
    }
};
